import { render } from "./InvoiceDetails.vue?vue&type=template&id=9d4cd7a8&scoped=true"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"

import "./InvoiceDetails.vue?vue&type=style&index=0&id=9d4cd7a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d4cd7a8"]])

export default __exports__